import { VssGiftAndAccount, VssPlan } from '@portal-middleware/hooks';

import { GiftingAlertMessageProps } from '../components/GiftingAlertMessage';

export const canGiftAccountRecieveGifts = (
  giftAndAccount: VssGiftAndAccount
): boolean => {
  if (!giftAndAccount) {
    return false;
  }
  const { accountPublic, giftAccount } = giftAndAccount;

  return (
    accountPublic &&
    accountPublic?.isActive &&
    giftAccount.canAcceptMoreGifts &&
    !giftAccount.deleted &&
    giftAccount.active
  );
};

const giftAccountDisabled = 'This account is no longer receiving gifts.';

export const getBlockerMessageProps = (
  giftAndAccount: VssGiftAndAccount,
  plan: VssPlan
): GiftingAlertMessageProps => {
  if (!giftAndAccount) {
    return {
      children: giftAccountDisabled,
      severity: 'error'
    };
  }
  const { accountPublic, giftAccount } = giftAndAccount;

  if (
    !giftAccount?.canAcceptMoreGifts &&
    plan.type === 'able' &&
    accountPublic?.isActive
  ) {
    return {
      children: `Good news, ${accountPublic.firstName} has reached the maximum contribution limit. Come back later.`,
      severity: 'info'
    };
  }

  if (
    !giftAccount?.canAcceptMoreGifts &&
    plan.type === 'collegeSavings' &&
    accountPublic?.isActive
  ) {
    return {
      children: `Good news, ${accountPublic.firstName} has reached the maximum account balance. Come back later.`,
      severity: 'info'
    };
  }

  if (accountPublic?.contributionHold) {
    return {
      children: `${accountPublic.firstName}'s account can’t accept contributions right now. Please try again later.`,
      severity: 'info'
    };
  }

  return {
    children: giftAccountDisabled,
    severity: 'error'
  };
};
